import { checkForNewUnlockedFeatures } from "../objects/check_for_new_unlocked_features";
import { payMonthlyCreditCardAmount } from "../objectsEndOfTurn/pay_monthly_credit_card_amount";
import { createIconTableObj } from "../objects/create_icon_table_obj";
import { calculateJobSalary } from "../../../objects/AssetsExpenses/calculate_job_salary";

export const processUnlockedFeatures = (gameData, creditCardInfo, monthlyIncome, 
        totalNbrGameMonths, rollForwardMonths, cashAmt, creditReport) => {
  
        // need to revise the following so will work for multiple months.... especially for
        // individuals who opt to only pay the minimum balance - spread charged amount across months 
        let feature = gameData.unlockedFeatures.find(elem => elem.featureName === "creditCard");
        let creditCardAmount = 0;
        let updateCreditCardSw = false;
        if (feature) {
            if (creditCardInfo.currentlyActive === true || creditCardInfo.totalOutstandingBalance > 0) {
                const creditCardObj = payMonthlyCreditCardAmount(creditCardInfo,
                    gameData.currentCash, gameData.currentGameDate, rollForwardMonths, gameData.expenseTable,
                    gameData.spendingHistory.turnCreditAmtArr);
                if (creditCardObj.cashError === true){
                    let iconTable = createIconTableObj("insufficientCash", gameData.iconTable);
                    gameData.iconTable = iconTable;
                }
                creditCardAmount = creditCardObj.minimumPayment;
                gameData.currentCash = (+creditCardObj.cashAmt.toFixed(2)).toString();
                creditCardInfo = creditCardObj.creditCardInfo;
                updateCreditCardSw = true;
            }
        }

        // the following function has been changed to 'downgrade' a feature if the player is no 
        // longer eligible
        const annualSalary = calculateJobSalary(gameData.assetTable, gameData.currentGameDate, false, "annual");
        const unlockedFeaturesObj = checkForNewUnlockedFeatures(gameData.gameNbrMonths,
                cashAmt, monthlyIncome, gameData.unlockedFeatures, totalNbrGameMonths,
                annualSalary, creditReport);
        let updateConditionsTable = false;
        if (unlockedFeaturesObj.changed === true) {
            gameData.unlockedFeatures = unlockedFeaturesObj.unlockedFeatures;
            if (unlockedFeaturesObj.newFeature === "creditCard"){ 
                const conditionObj={condName: "credit-card-unlocked", conditionClass: "game",
                        duration: -1};
                gameData.conditionsTable.push(conditionObj);
                updateConditionsTable = true;
            }
        }
           
        const returnObj = {unlockedFeatures: gameData.unlockedFeatures,  currentCash: gameData.currentCash,
            updateConditionsTable: updateConditionsTable, conditionsTable: gameData.conditionsTable,
            updateCreditCard: updateCreditCardSw, creditCardInfo: creditCardInfo, 
            creditCardAmount: creditCardAmount, iconTable: gameData.iconTable};
        return returnObj;
    }
        
export default processUnlockedFeatures;